import { Style } from '@components/style';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import DefaultUserTermsModal from '@components/member/ui/userTerms/components/defaultUserTermsModal';
import UserTermsModal from './components/userTermsModal';

const { secondaryColor } = new Style().getUiConfig();

function UserTerms({ userTerms, storeDisplay }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div>
      {/* User Terms Modal */}
      {userTerms ? (
        <UserTermsModal
          userTerms={userTerms}
          show={show}
          handleClose={handleClose}
        />
      ) : (
        <DefaultUserTermsModal
          storeDisplay={storeDisplay}
          show={show}
          handleClose={handleClose}
        />
      )}

      {/* User Terms Entrance */}
      <div className="text-center d-flex justify-content-center">
        <span className="align-self-center">
          <div
            role="presentation"
            style={{ color: secondaryColor, textDecorationLine: 'underline' }}
            onClick={handleShow}
          >
            <FormattedMessage id="member.userTerms.title" />
          </div>
        </span>
      </div>
    </div>
  );
}

UserTerms.defaultProps = {
  userTerms: '',
  storeDisplay: '',
};

UserTerms.propTypes = {
  userTerms: PropTypes.string,
  storeDisplay: PropTypes.string,
};

export default UserTerms;
